import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';
import { PieChartData } from 'app/modules/user/dashboard/dashboard.types';

@Component({
  selector: 'app-status-pill',
  templateUrl: './status-pill.component.html',
  styleUrls: ['./status-pill.component.scss']
})
export class StatusPillComponent implements OnInit, OnChanges {
    @Input() titleKey?: string;
    @Input() color?: 'primary' | 'accent' | 'warn' | 'basic' | 'info' | 'success' | 'warning' | 'error'

    tableData: PieChartData;

  constructor() { }
    ngOnChanges(changes: SimpleChanges): void {

    }
    ngOnInit(): void {
    }
}
